export const jointLedgerConstants = { 
    GET_LEDGERS_REQUEST: "GET_LEDGERS_REQUEST",
    GET_LEDGERS_SUCCESS: "GET_LEDGERS_SUCCESS",
    JOINT_LEDGERS_CLEAR: "JOINT_LEDGERS_CLEAR",
}
